import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { autoUpdate, offset, size, flip, shift, arrow, computePosition } from '@floating-ui/dom';

function useFloatingUI(element, _ref) {
  var referenceElement = _ref.referenceElement,
      popupElement = _ref.popupElement,
      arrowElement = _ref.arrowElement,
      _ref$arrowPadding = _ref.arrowPadding,
      arrowPadding = _ref$arrowPadding === void 0 ? 0 : _ref$arrowPadding,
      _ref$middleware = _ref.middleware,
      middleware = _ref$middleware === void 0 ? [] : _ref$middleware,
      _ref$offsetOptions = _ref.offsetOptions,
      offsetOptions = _ref$offsetOptions === void 0 ? 0 : _ref$offsetOptions,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
      flipOptions = _ref.flipOptions,
      shiftOptions = _ref.shiftOptions,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy,
      sync = _ref.sync,
      autoSize = _ref.autoSize,
      _ref$autoSizePadding = _ref.autoSizePadding,
      autoSizePadding = _ref$autoSizePadding === void 0 ? 0 : _ref$autoSizePadding;
  var cleanup;

  function reposition() {
    return _reposition.apply(this, arguments);
  } // Set the initial top and left position to minimize flickering when the popup is toggled on/off.


  function _reposition() {
    _reposition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var isOpen,
          _middleware,
          _yield$computePositio,
          x,
          y,
          _placement,
          _strategy,
          middlewareData,
          _middlewareData$arrow,
          _x,
          _y,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isOpen = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;

              if (!(!isOpen || !referenceElement || !popupElement)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              // Middlewares are order dependent: https://floating-ui.com/docs/middleware
              _middleware = [offset(offsetOptions)];

              if (sync) {
                _middleware.push(size({
                  apply: function apply(_ref2) {
                    var rects = _ref2.rects;
                    var syncWidth = sync === 'width' || sync === 'both';
                    var syncHeight = sync === 'height' || sync === 'both';
                    popupElement.style.width = syncWidth ? "".concat(rects.reference.width, "px") : '';
                    popupElement.style.height = syncHeight ? "".concat(rects.reference.height, "px") : '';
                  }
                }));
              } else {
                popupElement.style.width = '';
                popupElement.style.height = '';
              }

              _middleware.push(flip(flipOptions));

              _middleware.push(shift(shiftOptions));

              if (autoSize) {
                _middleware.push(size({
                  padding: autoSizePadding,
                  apply: function apply(_ref3) {
                    var availableWidth = _ref3.availableWidth,
                        availableHeight = _ref3.availableHeight;

                    if (autoSize === 'height' || autoSize === 'both') {
                      popupElement.style.setProperty('--awc-auto-size-height', "".concat(availableHeight, "px"));
                    } else {
                      popupElement.style.removeProperty('--awc-auto-size-height');
                    }

                    if (autoSize === 'width' || autoSize === 'both') {
                      popupElement.style.setProperty('--awc-auto-size-width', "".concat(availableWidth, "px"));
                    } else {
                      popupElement.style.removeProperty('--awc-auto-size-width');
                    }
                  }
                }));
              } else {
                popupElement.style.removeProperty('--awc-auto-size-height');
                popupElement.style.removeProperty('--awc-auto-size-width');
              }

              if (arrowElement) {
                _middleware.push(arrow({
                  element: arrowElement,
                  padding: arrowPadding
                }));
              }

              _middleware.concat(middleware);

              _context.next = 12;
              return computePosition(referenceElement, popupElement, {
                placement: placement,
                middleware: _middleware,
                strategy: strategy
              });

            case 12:
              _yield$computePositio = _context.sent;
              x = _yield$computePositio.x;
              y = _yield$computePositio.y;
              _placement = _yield$computePositio.placement;
              _strategy = _yield$computePositio.strategy;
              middlewareData = _yield$computePositio.middlewareData;
              Object.assign(popupElement.style, {
                left: "".concat(x, "px"),
                top: "".concat(y, "px"),
                position: _strategy
              });

              if (middlewareData.arrow && arrowElement) {
                _middlewareData$arrow = middlewareData.arrow, _x = _middlewareData$arrow.x, _y = _middlewareData$arrow.y;
                Object.assign(arrowElement.style, {
                  left: typeof _x === 'number' ? "".concat(_x, "px") : '',
                  top: typeof _y === 'number' ? "".concat(_y, "px") : ''
                });
              } // Bootstrap's arrow depends on this attribute.


              popupElement.setAttribute('x-placement', _placement);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _reposition.apply(this, arguments);
  }

  function forceStart() {
    if (!popupElement) return; // Fix floatingUI

    popupElement.style.position = strategy;
    popupElement.style.top = '0px';
    popupElement.style.left = '0px';
    if (!referenceElement) return;
    cleanup = autoUpdate(referenceElement, popupElement, function () {
      return reposition(true);
    });
    stop();
  }

  function start() {
    if (!referenceElement || !popupElement) return;
    cleanup = autoUpdate(referenceElement, popupElement, function () {
      return reposition(element.open);
    });
  }

  function update() {
    return _update.apply(this, arguments);
  }

  function _update() {
    _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return reposition(element.open);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _update.apply(this, arguments);
  }

  function stop() {
    return _stop.apply(this, arguments);
  }

  function _stop() {
    _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise(function (resolve) {
                if (cleanup) {
                  cleanup();
                  cleanup = undefined;
                  requestAnimationFrame(function () {
                    return resolve();
                  });
                } else {
                  resolve();
                }
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _stop.apply(this, arguments);
  }

  forceStart();
  var disconnectedCallback = element.disconnected.bind(element);
  Object.assign(element, {
    disconnected: function disconnected() {
      stop();
      disconnectedCallback();
    }
  });
  return {
    start: start,
    update: update,
    stop: stop
  };
}

export { useFloatingUI as default };